const VisPageRecovery = () => import('@/views/vis-page-recovery');

export default [
  {
    path: "/recovery",
    name: "recovery",
    component: VisPageRecovery,
    props: route => ({ state: route.query.state })
  }
]
